import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import LinearLoaderWithTime from "./LinearLoaderWithTime";
import { useTranslationApp } from "../../lib/i18next";
import { GALLERY_UPLOADING_ASSETS } from "../../i18n/keysTranslations";
import { AdleLogoLoader } from "../../assets/svg/AdleLogoLoader";
import { getConnectionBackdropZIndex } from "../../utils/modalLayer";

const ASSET_UPLOAD_LOADER_TIME_MS = 60 * 1000;

const AssetUploadLoader = ({ open = false }) => {
  const { t } = useTranslationApp();

  return (
    <Backdrop
      sx={{
        color: "#000",
        backgroundColor: "rgba(255, 255, 255, 0.99)",
        zIndex: getConnectionBackdropZIndex(),
      }}
      open={open}
    >
      <Box
        sx={{
          maxWidth: 720,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          px: 3,
        }}
      >
        <AdleLogoLoader />
        <LinearLoaderWithTime
          key={open ? "uploading" : "idle"}
          time={ASSET_UPLOAD_LOADER_TIME_MS}
          labels={[t(GALLERY_UPLOADING_ASSETS)]}
          labelSide="bottom"
          sx={{
            "& .MuiLinearProgress-root": {
              backgroundColor: "rgba(0, 0, 0, 0.2)",
              "& .MuiLinearProgress-bar": {
                backgroundColor: "#000",
              },
            },
            "& .MuiTypography-root": {
              color: "#000 !important",
            },
          }}
        />
      </Box>
    </Backdrop>
  );
};

export default AssetUploadLoader;
